import { cssVarV2 } from '@streamlain/theme/v2';

type ThemedScrollbarOptions = {
  gutter?: 'stable' | 'auto';
  size?: number;
  thumbMinSize?: number;
};

export function themedScrollbarStyle(
  selectors: string | string[],
  {
    gutter = 'stable',
    size = 4,
    thumbMinSize = 32,
  }: ThemedScrollbarOptions = {}
) {
  const selectorList = Array.isArray(selectors) ? selectors : [selectors];
  const join = (suffix = '') =>
    selectorList.map(s => `${s}${suffix}`).join(',\n  ');
  const thumb = cssVarV2.input.scrollBar.handle;
  const thumbHover = cssVarV2.layer.insideBorder.blackBorder;

  return `
  ${join()} {
    scrollbar-gutter: ${gutter};
    scrollbar-width: thin;
    scrollbar-color: ${thumb} transparent;
  }

  ${join('::-webkit-scrollbar')} {
    width: ${size}px;
    height: ${size}px;
  }

  ${join('::-webkit-scrollbar-track')} {
    background: transparent;
  }

  ${join('::-webkit-scrollbar-thumb')} {
    min-height: ${thumbMinSize}px;
    min-width: ${thumbMinSize}px;
    border: 2px solid transparent;
    border-radius: 999px;
    background-color: ${thumb};
    background-clip: padding-box;
  }

  ${join(':hover::-webkit-scrollbar-thumb')} {
    background-color: ${thumbHover};
  }

  ${join('::-webkit-scrollbar-corner')} {
    background: transparent;
  }
`;
}
